import { AuthProviderProps, UserManager } from 'oidc-react';

interface IConfig {
  APP_ID: string;
  API_URL: string;
  IAM_CLIENT_ID: string;
  IAM_AUTHORITY: string;
  /** b2b-konto-web – användaradministration för kontots revisorer. */
  KONTO_ADMIN_URL: string;
}

const config: IConfig = {
  API_URL: window.appConfig?.REACT_APP_API_URL || '',
  IAM_CLIENT_ID: window.appConfig?.REACT_APP_IAM_CLIENT_ID || '',
  IAM_AUTHORITY: window.appConfig?.REACT_APP_IAM_AUTHORITY || '',
  APP_ID: window.appConfig?.REACT_APP_APP_ID || '',
  KONTO_ADMIN_URL: window.appConfig?.REACT_APP_KONTO_ADMIN_URL || '',
};

/**
 * Exporterad så att main.tsx kan slutföra silent renew-iframen
 * (signinSilentCallback) och AuthLifecycle kan lyssna på token-events.
 */
const userManager = new UserManager({
  client_id: config.IAM_CLIENT_ID,
  post_logout_redirect_uri: `${window.location.origin}/`,
  redirect_uri: `${window.location.origin}/authentication/callback`,
  silent_redirect_uri: `${window.location.origin}/authentication/silent-callback`,
  scope: 'openid email',
  authority: config.IAM_AUTHORITY,
  // Förnyelsen sköts av AuthLifecycle (utils/sessionRenewal.ts) så att
  // realmens engångs-refresh-token aldrig löses in av två flöden samtidigt.
  automaticSilentRenew: false,
  metadata: {
    issuer: `${config.IAM_AUTHORITY}`,
    authorization_endpoint: `${config.IAM_AUTHORITY}/protocol/openid-connect/auth`,
    token_endpoint: `${config.IAM_AUTHORITY}/protocol/openid-connect/token`,
    introspection_endpoint: `${config.IAM_AUTHORITY}/protocol/openid-connect/token/introspect`,
    end_session_endpoint: `${config.IAM_AUTHORITY}/protocol/openid-connect/logout`,
    revocation_endpoint: `${config.IAM_AUTHORITY}/protocol/openid-connect/revoke`,
    userinfo_endpoint: `${config.IAM_AUTHORITY}/protocol/openid-connect/userinfo`,
  },
});

const auth_config: AuthProviderProps = {
  onSignIn: async (user: any) => {
    window.location.replace(user.state || '/');
  },
  onBeforeSignIn: () => {
    return window.location.href;
  },
  autoSignIn: true,
  // oidc-react loggar annars ut (signoutRedirect – avslutar SSO-sessionen)
  // vid varje misslyckad tyst förnyelse. Återhämtningen äger AuthLifecycle.
  autoSignOut: false,
  userManager,
};

export { config, auth_config, userManager };
